<template>
   <b-container>
      <h5
         style="
            font-weight: 600;
            margin-bottom: 30px;
            margin-left: 0;
            color: black;
            font-size: 1rem;
         "
      >
         Invite Another User
      </h5>
      <div>
         <b-form-row>
            <b-col cols="4">
               <b-form-group
                  label-for="input-first-name"
                  style="font-size: 13px"
                  class="font-weight-normal"
                  invalid-feedback="Required"
               >
                  <template #label>
                     First Name <label style="color: red; margin-bottom: 0">*</label></template
                  >
                  <b-form-input
                     id="input-first-name"
                     @input="
                        (value) =>
                           $store.commit('users/updateNewUser', {
                              index: 0,
                              field: 'firstName',
                              value,
                           })
                     "
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="4">
               <b-form-group
                  label-for="input-last-name"
                  style="font-size: 13px"
                  class="font-weight-normal"
                  invalid-feedback="Required"
               >
                  <template #label>
                     Last Name <label style="color: red; margin-bottom: 0">*</label></template
                  >
                  <b-form-input
                     id="input-last-name"
                     @input="
                        (value) =>
                           $store.commit('users/updateNewUser', {
                              index: 0,
                              field: 'lastName',
                              value,
                           })
                     "
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="4">
               <b-form-group
                  label-for="input-email"
                  invalid-feedback="Enter a valid email"
                  style="font-size: 13px"
                  class="font-weight-normal"
               >
                  <template #label>
                     Email <label style="color: red; margin-bottom: 0">*</label>
                  </template>
                  <b-form-input
                     id="input-email"
                     @input="
                        (value) =>
                           $store.commit('users/updateNewUser', {
                              index: 0,
                              field: 'email',
                              value,
                           })
                     "
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="4">
               <b-form-group
                  label="Job Title"
                  label-for="input-title"
                  style="font-size: 13px"
                  class="font-weight-normal"
               >
                  <b-form-input
                     id="input-title"
                     list="datalist-titles"
                     autocomplete="off"
                     @input="
                        (value) =>
                           $store.commit('users/updateNewUser', {
                              index: 0,
                              field: 'title',
                              value,
                           })
                     "
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="4">
               <b-form-group
                  label="Department"
                  label-for="input-department"
                  style="font-size: 13px"
                  class="font-weight-normal"
               >
                  <b-form-input
                     id="input-department"
                     list="datalist-departments"
                     autocomplete="off"
                     @input="
                        (value) =>
                           $store.commit('users/updateNewUser', {
                              index: 0,
                              field: 'department',
                              value,
                           })
                     "
                  ></b-form-input>
               </b-form-group>
            </b-col>
         </b-form-row>
      </div>

      <datalist id="datalist-titles">
         <option v-for="title in companyTitles" :key="title">
            {{ title }}
         </option>
      </datalist>

      <datalist id="datalist-departments">
         <option v-for="department in companyDepartments" :key="department">
            {{ department }}
         </option>
      </datalist>

      <div>
         <h5
            class="mb-4 mt-4"
            style="
               font-weight: 600;
               margin-bottom: 30px;
               margin-left: 0;
               color: black;
               font-size: 1rem;
            "
         >
            Permissions
         </h5>
         <div class="permission-item d-flex flex-row">
            <label :class="{'disabled-label': !hasPayrollPermission}" style="font-size: 14px">
               Create employees & view/edit payroll values
               <input
                  class="ml-2"
                  type="checkbox"
                  v-model="permissions.payroll"
                  :disabled="!hasPayrollPermission"
               />
            </label>
            <b-icon
               class="ml-2"
               v-if="!hasPayrollPermission"
               icon="exclamation-circle-fill"
               variant="primary"
               v-b-tooltip.left="`You cannot assign this permission, since you don't have it.`"
            ></b-icon>
         </div>
         <div class="permission-item d-flex flex-row">
            <label :class="{'disabled-label': !hasRevenuePermission}" style="font-size: 14px">
               View and edit company revenue values
               <input
                  class="ml-2"
                  type="checkbox"
                  v-model="permissions.revenue"
                  :disabled="!hasRevenuePermission"
               />
            </label>
            <b-icon
               class="ml-2"
               v-if="!hasRevenuePermission"
               icon="exclamation-circle-fill"
               variant="primary"
               v-b-tooltip.left="`You cannot assign this permission, since you don't have it.`"
            ></b-icon>
         </div>
         <div class="permission-item d-flex flex-row">
            <label
               :class="{'disabled-label': !hasContractorPaymentsPermission}"
               style="font-size: 14px"
            >
               Create contractors & view/edit payment values
               <input
                  class="ml-2"
                  type="checkbox"
                  v-model="permissions.contractorPayments"
                  :disabled="!hasContractorPaymentsPermission"
               />
            </label>
            <b-icon
               class="ml-2"
               v-if="!hasContractorPaymentsPermission"
               icon="exclamation-circle-fill"
               variant="primary"
               v-b-tooltip.left="`You cannot assign this permission, since you don't have it.`"
            ></b-icon>
         </div>
      </div>

      <div
         class="d-flex align-items-center justify-content-end cell-w-buttons"
         style="gap: 10px; margin-bottom: 60px"
      >
         <b-button variant="outline-primary" class="back-button" @click="cancelAction">
            Cancel
         </b-button>
         <b-button class="ok-btn" variant="primary" @click="submit" :disabled="$v.$invalid">
            <b-spinner variant="primary" small class="mr-2" v-if="!loaded"></b-spinner>
            Invite User
         </b-button>
      </div>
   </b-container>
</template>

<script>
import {mapGetters} from 'vuex';
import {required, email} from 'vuelidate/lib/validators';

import {clientUserSuggestions} from '@/mixins';
export default {
   mixins: [
      // Adds support for department/job title suggestions
      clientUserSuggestions,
   ],
   beforeCreate() {
      this.$store.commit('users/resetNewUsers');
   },
   data() {
      return {
         permissions: {
            payroll: false,
            revenue: false,
            contractorPayments: false,
         },
         loaded: true,
      };
   },

   computed: {
      ...mapGetters({
         users: 'users/newUsers',
         company: 'companies/currentCompany',
         isRndig: 'isRndig',
         isCustomer: 'isCustomer',
         profile: 'profile',
         currentUserPermissionFlags: 'users/currentUserPermissionFlags',
      }),

      /** The current company */
      companyId() {
         if (this.$route.params.id) {
            return this.$route.params.id;
         } else {
            return this.company.id;
         }
      },

      hasRevenuePermission() {
         if (this.isRndig) return true; // Rndig users has permissions
         return this.currentUserPermissionFlags.revenue;
      },

      hasPayrollPermission() {
         if (this.isRndig) return true; // Rndig users has permissions
         return this.currentUserPermissionFlags.payroll;
      },

      hasContractorPaymentsPermission() {
         if (this.isRndig) return true; // Rndig users has permissions
         return this.currentUserPermissionFlags.contractorPayments;
      },
   },

   methods: {
      cancelAction() {
         this.$emit('cancel-action');
      },
      /** Submit the new users */
      async submit() {
         if (this.$v.invalid) {
            return;
         }
         try {
            this.loaded = false;
            this.toggleDataLoading();
            const results = await this.blockingRequest('users/saveNewUsers', {
               companyId: this.companyId,
            });

            for (const result of results) {
               if (result.value.user.id) {
                  try {
                     await this.$store.dispatch('users/createUserPermissions', {
                        userId: result.value.user.id,
                        payroll: this.permissions.payroll,
                        revenue: this.permissions.revenue,
                        contractorPayments: this.permissions.contractorPayments,
                        isInvitation: this.isCustomer,
                     });
                  } catch (e) {
                     console.log(e);
                  }
               }
            }

            this.loadSuggestions(true);
            results
               .filter((result) => result.value.error)
               .forEach((result) => {
                  this.$store.commit('showAlert', {
                     msg: `Failed to create user: ${result.value.user.email}`,
                     seconds: 5,
                  });
               });
            this.$emit('submit-action', results[0].value.user);
         } catch (e) {
            console.error(e);
            this.$emit('submit-action', null);
         } finally {
            this.loaded = true;
            this.toggleDataLoading();
         }
      },
   },

   validations() {
      return {
         users: {
            $each: {
               firstName: {required},
               lastName: {required},
               email: {
                  required,
                  email,
               },
            },
         },
      };
   },
};
</script>

<style scoped>
.back-button {
   padding: 5px 30px;
   font-size: 13px !important;
   background-color: transparent !important;
   color: #0978cd !important;

   &:hover {
      background-color: transparent !important;
      color: #0978cd !important;
   }
}

.disabled-label {
   color: lightgray;
}

.ok-btn {
   padding: 5px 30px;
   font-size: 13px !important;
   background-color: #0978cd !important;
   border: 1px solid #0978cd;
   &:hover {
      background-color: #0978cd !important;
      border: 1px solid #0978cd;
   }
}
</style>
